import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Clock, ExternalLink } from 'lucide-react';
import { formatNewsDate } from './newsUtils';

const NewsCard = ({ item, idx }) => (
  <Card className="hover:shadow-lg transition-shadow" data-testid={`news-item-${idx}`}>
    <CardContent className="p-6">
      {item.image && (
        <div className="h-40 -mx-6 -mt-6 mb-4 overflow-hidden rounded-t-lg bg-gray-100">
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}

      <div className="flex items-start justify-between mb-3">
        <Badge variant="outline" className="text-xs">
          {item.source || 'News'}
        </Badge>
        <div className="flex items-center text-xs text-gray-500">
          <Clock size={12} className="mr-1" />
          {formatNewsDate(item.datetime)}
        </div>
      </div>

      <h3 className="font-bold text-lg text-gray-900 mb-2 line-clamp-2 hover:text-purple-600">
        <a href={item.url} target="_blank" rel="noopener noreferrer">
          {item.title}
        </a>
      </h3>

      <p className="text-gray-600 text-sm mb-4 line-clamp-3">{item.summary}</p>

      <div className="flex items-center justify-between">
        {item.related && (
          <div className="flex gap-1 flex-wrap">
            {item.related
              .split(',')
              .slice(0, 3)
              .map((ticker) => {
                const sym = ticker.trim();
                return (
                  <Badge key={sym} variant="secondary" className="text-xs">
                    ${sym}
                  </Badge>
                );
              })}
          </div>
        )}
        <a
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 text-purple-600 hover:text-purple-700 text-sm font-medium ml-auto"
        >
          Read more
          <ExternalLink size={14} />
        </a>
      </div>
    </CardContent>
  </Card>
);

const NewsGrid = ({ news }) => (
  <div className="grid lg:grid-cols-2 gap-6">
    {news.map((item, idx) => (
      <NewsCard key={item.id || item.url || idx} item={item} idx={idx} />
    ))}
  </div>
);

export default NewsGrid;
